export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6167.d7dd5e35.jpg";